import type { DriverType } from '@ria-client/supergraph/marketplace/types';
import { DisclosureTooltip } from '@ria-client/tw-shared-ui';
import { CircleHelp } from 'lucide-react';

export interface DriverCellProps {
  driver?: DriverType;
}

export function DriverCell({ driver }: DriverCellProps) {
  const value = getValue(driver);

  return (
    <div className="flex flex-col gap-0.5">
      <div className="flex gap-0.5 leading-6">
        <span className="typography-text">{value}</span>
        {driver?.valueTooltip ? (
          <DisclosureTooltip
            trigger={
              <button aria-label={`${driver.label} info`} type="button">
                <CircleHelp aria-hidden />
              </button>
            }
          >
            <span className="typography-text-small">{driver.valueTooltip}</span>
          </DisclosureTooltip>
        ) : null}
      </div>
      {driver?.description ? (
        <span className="typography-text-small text-muted-foreground">{driver.description}</span>
      ) : null}
    </div>
  );
}

function getValue(driver?: DriverType) {
  if (!driver?.value && driver?.label === 'Overdraft star rating') {
    return 'Not rated yet';
  }
  if (!driver?.value) {
    return 'N/A';
  }

  return driver.value.replace('-', ' -\n');
}
